import { __decorate, __extends } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import VueCountdown from '@chenfengyuan/vue-countdown';
import CheckView from 'vue-check-view';
import CountdownTemplate from './countdown-template.vue';
import { VueEventBus } from '../../../vue-event-bus';
Vue.use(CheckView);
var Countdown = /** @class */ (function (_super) {
    __extends(Countdown, _super);
    function Countdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.countdownObject = {
            day: 'Tage',
            hour: 'Stunden',
            minute: 'Minuten',
            second: 'Sekunden'
        };
        _this.isEnabled = false;
        _this.isSliderChild = false;
        _this.time = 0;
        _this.id = 'cntdwn' + Date.now();
        _this.selectors = {
            slider: 'c-slider',
            currentSlide: '.slick-slide.slick-active',
            id: '#' + _this.id
        };
        return _this;
    }
    Countdown.prototype.mounted = function () {
        var _this = this;
        this.countdownObject = this.countdown ? this.setCountdownObject() : this.countdownObject;
        this.countdownElement = this.$refs.countdown;
        this.time = this.calculateTime();
        this.isSliderChild = this.setIsSliderChild();
        this.isEnabled = true;
        if (this.isSliderChild) {
            VueEventBus.$on('sliderChanged', function (slide) {
                var countdownElement = slide.querySelector(_this.selectors.id);
                _this.isEnabled = !!countdownElement;
            });
        }
    };
    Countdown.prototype.calculateTime = function () {
        var difference = (new Date(this.date).getTime() - Date.now());
        return difference > 0 ? difference : 0;
    };
    Countdown.prototype.isCurrentSlide = function () {
        return !!this.countdownElement.closest(this.selectors.currentSlide);
    };
    Countdown.prototype.setCountdownObject = function () {
        if (typeof this.countdown === 'string' && this.countdown.length > 0) {
            return JSON.parse(this.countdown);
        }
        else if (typeof this.countdown_encoded === 'string' && this.countdown_encoded.length > 0) {
            var decoded = this.countdown_encoded.replace("'", '"');
            return JSON.parse(decoded);
        }
        return this.countdown;
    };
    Countdown.prototype.setIsSliderChild = function () {
        return !!this.countdownElement.closest(this.selectors.slider);
    };
    Countdown.prototype.addLeadingZeros = function (props) {
        var additionalHours = (props.days) * 24;
        for (var key in props) {
            var value = props[key];
            if (this.isHourCount && key == 'hours') {
                value = (value) + additionalHours;
            }
            props[key] = value < 10 ? "0".concat(value) : value;
        }
        return props;
    };
    Countdown.prototype.viewHandler = function (e) {
        var currentState = e.percentInView > 0;
        if ((currentState !== this.isEnabled) &&
            (!this.isSliderChild || (this.isSliderChild && this.isCurrentSlide()))) {
            this.isEnabled = currentState;
            this.time = this.calculateTime();
        }
    };
    __decorate([
        Prop()
    ], Countdown.prototype, "isHourCount", void 0);
    __decorate([
        Prop({ default: '' })
    ], Countdown.prototype, "date", void 0);
    __decorate([
        Prop()
    ], Countdown.prototype, "countdown", void 0);
    __decorate([
        Prop()
    ], Countdown.prototype, "countdown_encoded", void 0);
    Countdown = __decorate([
        Component({
            components: {
                VueCountdown: VueCountdown,
                CountdownTemplate: CountdownTemplate
            }
        })
    ], Countdown);
    return Countdown;
}(Vue));
export default Countdown;
